import React from "react";
import ExpandableText from "../ExpandableText/ExpandableText";
import "./CollectionCover.scss";

const DESCRIPTION_MAX_LENGTH = 500;
const SUBTITLE_MAX_LENGTH = 100;

/**
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {string} [props.subtitle]
 * @param {string[]} [props.tags]
 * @param {string} [props.description]
 * @param {string} [props.ctaLabel]
 * @param {() => void} [props.onCtaClick]
 * @param {string} [props.ctaHref]
 * @param {string} [props.image]
 * @param {string[]} [props.images]
 */
const CollectionCover = ({
  title,
  subtitle = "",
  tags = [],
  description = "",
  ctaLabel = "View Collection",
  onCtaClick,
  ctaHref,
  image,
  images = [],
}) => {
  const hasCollage = images.length > 0;

  const renderCta = () => {
    if (!ctaLabel) return null;

    if (ctaHref) {
      return (
        <a className="CollectionCover-cta" href={ctaHref}>
          {ctaLabel}
        </a>
      );
    }

    return (
      <button
        type="button"
        className="CollectionCover-cta"
        onClick={onCtaClick}
      >
        {ctaLabel}
      </button>
    );
  };

  return (
    <section className="CollectionCover">
      <div className="CollectionCover-content">
        <div className="CollectionCover-info">
          <div>
            <h1 className="CollectionCover-title">{title}</h1>
            <ExpandableText
              text={subtitle}
              maxLength={SUBTITLE_MAX_LENGTH}
              className="CollectionCover-subtitle"
              toggleClassName="CollectionCover-readMore"
            />
          </div>

          <div>
            {tags.length > 0 && (
              <div className="CollectionCover-tags">
                {tags.map((tag) => (
                  <span className="CollectionCover-tag" key={tag}>
                    {tag}
                  </span>
                ))}
              </div>
            )}

            <ExpandableText
              text={description}
              maxLength={DESCRIPTION_MAX_LENGTH}
              className="CollectionCover-description"
              toggleClassName="CollectionCover-readMore"
            />
          </div>
          {renderCta()}
        </div>

        <div className="CollectionCover-media">
          {hasCollage ? (
            <div className="CollectionCover-collage">
              {images.slice(0, 6).map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`${title} preview ${index + 1}`}
                  className="CollectionCover-collage-item"
                />
              ))}
            </div>
          ) : (
            image && (
              <img src={image} alt={title} className="CollectionCover-image" />
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default CollectionCover;
